import React from 'react';

export const CRISIS_GUIDANCE_TEXT =
  'Peace Love Wellness is not a crisis service. If you might hurt yourself or someone else, or you need immediate support, call or text 988 for the Suicide & Crisis Lifeline. If you can, you may also contact a trusted person, a local mobile crisis team, a peer respite center, or another community-based crisis resource near you. If there is immediate physical danger and no safer support is available, use emergency services.';

// Clear glass with sage light and a sage rule (.crisis-note in index.css).
// Text roles adapt to where it sits: the canvas, or the footer panel.
export default function CrisisGuidance({ className = '' }) {
  return (
    <aside className={`crisis-note rounded-tile px-5 py-4 ${className}`}>
      <p className="text-sm font-medium text-ink">Need support right now?</p>
      <p className="mt-2 text-sm leading-relaxed font-normal text-ink-muted">{CRISIS_GUIDANCE_TEXT}</p>
    </aside>
  );
}
